<template>
  <div class="d-flex flex-column">
    <div class="text-center">
      <a
        :href="appUrl"
        target="_blank"
      >
        <img
          alt="app-logo"
          height="64px"
          :src="appLogo"
        />
      </a>
    </div>

    <div>
      <h1 class="mt-0">
        {{ $t("commons.otp_title") }}
      </h1>
      <p>
        <span
          class="h4 font-weight-light my-5"
          v-html="$t('commons.mfa_text_email')"
        ></span>
      </p>
    </div>

    <v-form
      ref="form"
      v-model="isFormValid"
      class="mt-5"
    >
      <v-text-field
        v-model="mfaForm.code"
        :label="$t('commons.otp_title')"
        :rules="rules.code"
        required
      />

      <v-btn
        large
        :loading="loading"
        :disabled="!isFormValid || loading"
        color="blue white--text"
        block
        @click="submit"
      >
        {{ $t("views.signup_in.signin") }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { required } from "@/utils/validator"
import { AccountService } from "@/services"

export default {
  data() {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo,
      appUrl: this.$appConfig.url,
      isFormValid: false,
      rules: {
        code: [required]
      },
      mfaForm: {
        code: ""
      },
      loading: false,
      tempToken: this.$route.query.temp_token // Récupération du temp_token depuis l'URL ou la route
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    submit() {
      if (this.loading) return
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.isFormValid) {
          this.loading = true
          AccountService.sendMfa(
            this,
            {
              code: this.mfaForm.code,
              temp_token: this.tempToken // Envoyer le token temporaire avec le code MFA
            },
            this.$route.query.redirect
          )
            .then(result => {
              this.$router.push({ name: "Home" }) // Rediriger après succès
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  },
  mounted() {
    this.$refs.form.reset()
  }
}
</script>
